class DeviceCarousel {
  constructor() {
    this.currentSlide = 0;
    this.totalSlides = 4;
    this.autoPlayInterval = 4000;
    this.isPlaying = true;

    this.init();
  }

  init() {
    this.bindEvents();
    this.startAutoPlay();
    this.preloadImages();
  }

  bindEvents() {
    // Navigation dots
    document.querySelectorAll('.nav-dot').forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // Pause on hover
    const devicesContainer = document.querySelector('.devices-container');
    devicesContainer.addEventListener('mouseenter', () => this.pauseAutoPlay());
    devicesContainer.addEventListener('mouseleave', () => this.resumeAutoPlay());

    // Touch/swipe support for mobile
    let startX = 0;
    let endX = 0;

    devicesContainer.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });

    devicesContainer.addEventListener('touchend', (e) => {
      endX = e.changedTouches[0].clientX;
      this.handleSwipe();
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.previousSlide();
      if (e.key === 'ArrowRight') this.nextSlide();
    });
  }

  handleSwipe() {
    const threshold = 50;
    const diff = startX - endX;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.nextSlide();
      } else {
        this.previousSlide();
      }
    }
  }

  goToSlide(slideIndex) {
    if (slideIndex === this.currentSlide) return;

    // Hide current slides
    this.hideCurrentSlides();

    // Update current slide
    this.currentSlide = slideIndex;

    // Show new slides with slight delay for smooth transition
    setTimeout(() => {
      this.showCurrentSlides();
    }, 100);

    // Update navigation
    this.updateNavigation();
  }

  hideCurrentSlides() {
    document.querySelectorAll('.screenshot.active').forEach(screenshot => {
      screenshot.classList.remove('active');
    });
  }

  showCurrentSlides() {
    // Show desktop screenshot
    const desktopScreenshot = document.querySelector(`.desktop-screenshot-${this.currentSlide + 1}`);
    if (desktopScreenshot) {
      desktopScreenshot.classList.add('active');
    }

    // Show mobile screenshot
    const mobileScreenshot = document.querySelector(`.mobile-screenshot-${this.currentSlide + 1}`);
    if (mobileScreenshot) {
      mobileScreenshot.classList.add('active');
    }
  }

  updateNavigation() {
    document.querySelectorAll('.nav-dot').forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentSlide);
    });
  }

  nextSlide() {
    const nextIndex = (this.currentSlide + 1) % this.totalSlides;
    this.goToSlide(nextIndex);
  }

  previousSlide() {
    const prevIndex = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    this.goToSlide(prevIndex);
  }

  startAutoPlay() {
    if (this.autoPlayTimer) return;

    this.autoPlayTimer = setInterval(() => {
      if (this.isPlaying) {
        this.nextSlide();
      }
    }, this.autoPlayInterval);
  }

  pauseAutoPlay() {
    this.isPlaying = false;
  }

  resumeAutoPlay() {
    this.isPlaying = true;
  }

  stopAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer);
      this.autoPlayTimer = null;
    }
  }

  preloadImages() {
    // In a real implementation, you would preload your actual screenshot images here
    // Example:
    // const images = ['screenshot1.jpg', 'screenshot2.jpg', 'screenshot3.jpg'];
    // images.forEach(src => {
    //     const img = new Image();
    //     img.src = src;
    // });
  }
}

export default DeviceCarousel;
